import { useState } from 'react'
import LinkInputs from './LinkInputs'
import ExtraInfoTab from './ExtraInfoTab'
import VideoPlayerSection from './VideoPlayerSection'

const PostContentTabs = ({
  links,
  setLinks,
  refUploadCode,
  updateInfo,
  setUpdateInfo,
  installationGuide,
  setInstallationGuide,
  minimumSystemRequirement,
  setMinimumSystemRequirement,
  recommendedSystemRequirement,
  setRecommendedSystemRequirement,
  showSystemRequirements,
  isVideo = false,
  videos = [],
  setVideos,
}) => {
  const [activeTab, setActiveTab] = useState('links')

  return (
    <div className="postContentTabs">
      <div className="postContentTabs__bar">
        <button
          type="button"
          className={activeTab === 'links' ? 'active' : ''}
          onClick={() => setActiveTab('links')}
        >
          لینک های دانلود
        </button>
        {isVideo && (
          <button
            type="button"
            className={activeTab === 'online' ? 'active' : ''}
            onClick={() => setActiveTab('online')}
          >
            پخش آنلاین
          </button>
        )}
        <button
          type="button"
          className={activeTab === 'extra' ? 'active' : ''}
          onClick={() => setActiveTab('extra')}
        >
          اطلاعات تکمیلی
        </button>
      </div>

      {activeTab === 'links' && (
        <LinkInputs
          data={links}
          setData={setLinks}
          refUploadCode={refUploadCode}
          isVideo={isVideo}
        />
      )}

      {isVideo && activeTab === 'online' && (
        <VideoPlayerSection videos={videos} setVideos={setVideos} />
      )}

      {activeTab === 'extra' && (
        <ExtraInfoTab
          updateInfo={updateInfo}
          setUpdateInfo={setUpdateInfo}
          installationGuide={installationGuide}
          setInstallationGuide={setInstallationGuide}
          minimumSystemRequirement={minimumSystemRequirement}
          setMinimumSystemRequirement={setMinimumSystemRequirement}
          recommendedSystemRequirement={recommendedSystemRequirement}
          setRecommendedSystemRequirement={setRecommendedSystemRequirement}
          showSystemRequirements={showSystemRequirements}
        />
      )}
    </div>
  )
}

export default PostContentTabs
